import script from "./SuspiciousConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspiciousConfirm.vue?vue&type=script&setup=true&lang=js"

import "./SuspiciousConfirm.vue?vue&type=style&index=0&id=a8d6e0ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8d6e0ec"]])

export default __exports__